const initSlider = () => {
    new Swiper('.related-products-slider', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        navigation: {
            prevEl: '.related-products-slider-button-prev',
            nextEl: '.related-products-slider-button-next'
        },
        breakpoints: {
            992: {
                autoplay: false
            }
        } 
    })
}

const initProductRecommendations = () => {
    const relatedProducts = document.querySelector('.related-products')

    if(!relatedProducts) { return }

    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
    
        observer.unobserve(productRecommendationsSection);
    
        const url = productRecommendationsSection.dataset.url;
    
        fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.related-products');
    
            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
              initSlider()
            }
          })
          .catch(e => {
            console.error(e);
          });
      };
    
      const productRecommendationsSection = document.querySelector('.related-products');
      const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    
      observer.observe(productRecommendationsSection);
    
      
}

export { initProductRecommendations }